const stretch = "cui-button-stretch-viqu";
const s = "cui-button-s-yzpu";
const m = "cui-button-m-9sec";
const tertiary = "cui-button-tertiary-qgem";
const classes = {
  stretch,
  s,
  m,
  tertiary
};
export {
  classes as default,
  m,
  s,
  stretch,
  tertiary
};
